const hiKundli = {
  // Errors & validation
  "please_fill_required_fields": "कृपया सभी आवश्यक विवरण भरें।",
  "invalid_email_format": "कृपया मान्य ईमेल पता दर्ज करें।",
  "invalid_phone_format": "कृपया मान्य फ़ोन नंबर दर्ज करें।",
  "payment_failed_message": "भुगतान असफल रहा। कृपया पुनः प्रयास करें या सहायता से संपर्क करें।",

  // Header & hero
  "cosmic_career": "पृष्ठों की कुंडली रिपोर्ट",
  "journey": "आपका संपूर्ण जीवन विश्लेषण",
  "discover_professional_destiny": "व्यक्तिगत वैदिक ज्योतिष रिपोर्ट — करियर, रिश्ते, स्वास्थ्य और उपाय — 24 घंटे में उपलब्ध।",

  // Form labels
  "full_name": "पूरा नाम",
  "enter_complete_name": "अपना पूरा नाम दर्ज करें",
  "gender": "लिंग",
  "male": "पुरुष",
  "female": "महिला",
  "other": "अन्य",
  "email_address": "ईमेल पता",
  "email_placeholder": "aapka@email.com",
  "phone_number": "फ़ोन नंबर",
  "phone_placeholder": "+91 1234567890",
  "your_birth_date": "आपकी जन्म तिथि",
  "birth_time": "जन्म समय",
  "birth_place": "जन्म स्थान",
  "city_state_country": "शहर, राज्य, देश",
  "preferred_language": "पसंदीदा भाषा",
  "english": "🇺🇸 अंग्रेज़ी",
  "hindi": "🇮🇳 हिंदी",
  "telugu": "🇮🇳 तेलुगु",
  "kannada": "🇮🇳 कन्नड़",
  "tamil": "🇮🇳 तमिल",
  "marathi": "🇮🇳 मराठी",
  "bengali": "🇮🇳 बांग्ला",

  // Benefits (what you'll receive)
  "what_youll_receive": "आपको क्या मिलेगा",
  "life_kundali_20_years": "समग्र कुंडली — करियर, रिश्ते, स्वास्थ्य और वित्तीय क्षेत्रों में दीर्घकालीन मार्गदर्शन।",
  "detailed_career_path_analysis": " PDF — चार्ट, योग, दशा, गोचर और चित्रात्मक व्याख्या के साथ।",
  "planetary_position_interpretations": "ग्रहों की स्थिति और भावों का स्पष्ट विश्लेषण — सरल और पढ़ने योग्य शैली में।",
  "dasha_system_predictions": "दशा और गोचर आधारित भविष्यवाणियाँ — सही समय पर सही निर्णय लेने में मदद।",
  "personalized_remedial_suggestions": "व्यक्तिगत उपाय और रत्न सिफारिशें — कठिन समय को संतुलित करने के लिए।",
  "digital_pdf_report": "डिजिटल PDF — व्हाट्सएप या ईमेल से 24 घंटे के भीतर भेजी जाएगी।",

  // Pricing/checkout
  "unlock_your_destiny_title": "अपनी पूरी रिपोर्ट प्राप्त करें",
  "complete_cosmic_journey_desc": "फॉर्म भरें और अपनी व्यक्तिगत  की ज्योतिष रिपोर्ट प्राप्त करें।",
  "premium": "प्रीमियम रिपोर्ट",
  "career_path_analysis": "संपूर्ण जीवन विश्लेषण रिपोर्ट",
  "processing_payment": "भुगतान प्रक्रिया जारी है...",
  "preparing_analysis": "आपकी  की रिपोर्ट तैयार हो रही है...",
  "complete_payment_get_report": "🚀 भुगतान पूरा करें और रिपोर्ट प्राप्त करें",

  // Trust indicators
  "reports_generated": "15,000+ रिपोर्टें प्रदान की गईं",
  "rating": "उपयोगकर्ताओं द्वारा 4.9/5 रेटिंग",
  "secure": "🔒 सुरक्षित भुगतान प्रणाली",

  // API / runtime messages
  "failed_to_load_payment": "भुगतान गेटवे लोड नहीं हुआ। कृपया पुनः प्रयास करें।",
  "failed_to_create_order": "ऑर्डर नहीं बन पाया। कृपया पुनः प्रयास करें।",
  "failed_to_initialize_payment": "भुगतान प्रारंभ असफल रहा। थोड़ी देर में पुनः प्रयास करें।",
  "failed_to_open_payment_gateway": "भुगतान विंडो नहीं खुली। कृपया पुनः प्रयास करें।",

  // Service details
  "birth_chart_analysis": "व्यक्तिगत ज्योतिष रिपोर्ट",
  "complete_kundli_report": " की वैदिक कुंडली रिपोर्ट - जीवन के सभी पहलू शामिल",
  "service_amount": "₹599",

  "advanced_astrology_suite": "उन्नत ज्योतिष पैकेज",
  "suite_summary": "समयरेखा, अनुकूलता और स्पष्ट विश्लेषण के साथ गहन ज्योतिष रिपोर्ट — पढ़ने और साझा करने में आसान।",
  "feature_reports": "समग्र रिपोर्ट — स्पष्ट फॉर्मेटिंग और दृश्य अनुभागों के साथ।",
  "feature_compatibility": "अनुकूलता विश्लेषण और समयरेखा — महत्वपूर्ण निर्णयों के लिए सहायक।",
  "feature_multilingual": "बहुभाषी रिपोर्टें और मोबाइल/डिवाइस अनुकूल डिज़ाइन।",
  "report_preview_alt": "रिपोर्ट पूर्वावलोकन",
  "get_my_report": "मेरी रिपोर्ट प्राप्त करें",
  "autocomplete_hint": "अपना शहर लिखना शुरू करें; सुझाव स्वतः दिखाई देंगे"
};
export default hiKundli;


// const hiKundli = {
//   // Error Messages
//   "please_fill_required_fields": "कृपया सभी आवश्यक फ़ील्ड भरें।",
//   "invalid_email_format": "कृपया एक मान्य ईमेल पता दर्ज करें।",
//   "invalid_phone_format": "कृपया एक मान्य फ़ोन नंबर दर्ज करें।",
//   "payment_failed_message": "भुगतान असफल रहा। कृपया पुनः प्रयास करें या सहायता से संपर्क करें।",

//   // Step Configuration
//   "personal_identity": "व्यक्तिगत जानकारी",
//   "tell_us_about_yourself": "शुरू करने के लिए हमें अपने बारे में बताएं",
//   "birth_details": "जन्म विवरण",
//   "your_cosmic_coordinates": "आपके विश्लेषण की शुरुआत के लिए हमें आपके जन्म विवरण की आवश्यकता है",
//   "time_and_place": "जन्म का समय और स्थान",
//   "when_and_where_arrived": "आपका जन्म कब और कहाँ हुआ था?",
//   "your_preferences": "भाषा वरीयता",
//   "customize_experience": "रिपोर्ट के लिए अपनी पसंदीदा भाषा चुनें",
//   "unlock_your_destiny": "अपनी 200+ पेज की कुंडली प्राप्त करें",
//   "complete_cosmic_journey": "पूरी रिपोर्ट पाने के लिए अपने विवरण भरें",

//   // Step 0: Personal Details
//   "who_are_you": "आप कौन हैं?",
//   "start_with_basics": "शुरुआत के लिए हमें कुछ बुनियादी जानकारी दें",
//   "full_name": "पूरा नाम",
//   "enter_complete_name": "अपना पूरा नाम दर्ज करें",
//   "gender": "लिंग",
//   "male": "पुरुष",
//   "female": "महिला",
//   "other": "अन्य",
//   "email_address": "ईमेल पता",
//   "email_placeholder": "your@email.com",
//   "phone_number": "फ़ोन नंबर",
//   "phone_placeholder": "+91 1234567890",

//   // Step 1: Birth Date
//   "your_birth_date": "आपकी जन्म तिथि",
//   "cosmic_journey_begin": "आपकी ब्रह्मांडीय यात्रा कब शुरू हुई?",
//   "age_label": "आयु",
//   "years": "वर्ष",

//   // Step 2: Time & Place
//   "time_and_place_title": "जन्म का समय और स्थान",
//   "precise_moment_location": "सटीक समय और स्थान सही गणना सुनिश्चित करते हैं",
//   "birth_time": "जन्म का समय",
//   "select_exact_time": "अपना सटीक जन्म समय चुनें",
//   "birth_place": "जन्म स्थान",
//   "city_state_country": "शहर, राज्य, देश",
//   "location_accuracy": "स्थान की सटीकता",
//   "exact_birthplace_ensures": "सटीक जन्मस्थान ग्रहों की सटीक स्थिति सुनिश्चित करता है",

//   // Step 3: Preferences
//   "your_preferences_title": "भाषा चुनें",
//   "customize_astrological_experience": "अपनी व्यक्तिगत रिपोर्ट के लिए भाषा चुनें",
//   "preferred_language": "पसंदीदा भाषा",
//   "english": "🇺🇸 अंग्रेज़ी",
//   "hindi": "🇮🇳 हिंदी",
//   "telugu": "🇮🇳 तेलुगु",
//   "kannada": "🇮🇳 कन्नड़",
//   "tamil": "🇮🇳 तमिल",
//   "marathi": "🇮🇳 मराठी",
//   "bengali": "🇮🇳 बंगाली",
//   "what_youll_receive": "आपको क्या मिलेगा",
//   "life_kundali_20_years": "जीवन कुंडली जिसमें 20 वर्षों की भविष्यवाणी — करियर, प्रेम, स्वास्थ्य और धन के लिए वर्ष-दर-वर्ष मार्गदर्शन",
//   "detailed_career_path_analysis": "200+ पृष्ठ की पीडीएफ कुंडली रिपोर्ट",
//   "planetary_position_interpretations": "20+ ज्योतिषीय प्रणालियों को कवर करता है",
//   "dasha_system_predictions": "करियर, विवाह, स्वास्थ्य और जीवन की भविष्यवाणी शामिल",
//   "personalized_remedial_suggestions": "व्यक्तिगत उपाय और रत्न सुझाव",
//   "digital_pdf_report": "व्हाट्सएप या ईमेल के माध्यम से 24 घंटे के भीतर भेजी जाएगी",

//   // Step 4: Payment
//   "unlock_your_destiny_title": "अपनी पूरी रिपोर्ट प्राप्त करें",
//   "complete_cosmic_journey_desc": "फॉर्म भरें और अपनी व्यक्तिगत 200+ पृष्ठ की ज्योतिषीय रिपोर्ट प्राप्त करें",
//   "premium": "प्रीमियम रिपोर्ट",
//   "career_path_analysis": "पूरी जीवन विश्लेषण रिपोर्ट",
//   "off_label": "छूट",
//   "summary_of_details": "आपका सारांश:",
//   "name_label": "नाम:",
//   "birth_date_label": "जन्म तिथि:",
//   "birth_time_label": "जन्म समय:",
//   "birth_place_label": "जन्म स्थान:",
//   "processing_payment": "भुगतान प्रक्रिया में...",
//   "preparing_analysis": "आपकी 200+ पृष्ठ की रिपोर्ट तैयार हो रही है...",
//   "complete_payment_get_report": "🚀 भुगतान पूरा करें और रिपोर्ट प्राप्त करें",

//   // Navigation
//   "previous": "← पिछला",
//   "step_of": "कदम",
//   "of": "में से",
//   "next": "अगला →",
//   "review_and_pay": "समीक्षा करें और भुगतान करें",

//   // Validation Messages
//   "fill_personal_details": "कृपया सभी आवश्यक व्यक्तिगत विवरण भरें",
//   "select_birth_date": "कृपया अपनी जन्म तिथि चुनें",
//   "provide_birth_time_place": "कृपया सही जन्म समय और स्थान प्रदान करें",

//   // Header
//   "cosmic_career": "200+ पृष्ठ की कुंडली रिपोर्ट",
//   "journey": "आपका संपूर्ण जीवन विश्लेषण",
//   "discover_professional_destiny": "अपनी व्यक्तिगत वैदिक ज्योतिष रिपोर्ट प्राप्त करें जिसमें करियर, प्रेम, स्वास्थ्य और उपाय शामिल हैं — 24 घंटे में डिलीवर। जीवन कुंडली जिसमें 20 वर्षों की भविष्यवाणी — करियर, प्रेम, स्वास्थ्य और धन के लिए वर्ष-दर-वर्ष मार्गदर्शन",

//   // Trust Indicators
//   "reports_generated": "15,000+ रिपोर्ट डिलीवर की गईं",
//   "rating": "4.9/5 उपयोगकर्ताओं द्वारा रेटेड",
//   "secure": "🔒 सुरक्षित और संरक्षित भुगतान",

//   // Thank You Page Service Features
//   "detailed_career_guidance_pdf": "पूरा करियर और जीवन पथ मार्गदर्शन",
//   "comprehensive_astrological_analysis": "20+ ज्योतिषीय प्रणालियों पर आधारित",
//   "planetary_positions_interpretations": "दशा, गोचर, नक्षत्र, अंक ज्योतिष शामिल",
//   "dasha_system_predictions_feature": "भविष्यवाणी, ग्रहों की समयावधि",
//   "personalized_remedial_suggestions_feature": "कस्टम उपाय, रत्न और दोष रिपोर्ट",

//   // API Related Messages
//   "failed_to_load_payment": "भुगतान गेटवे लोड करने में विफल। कृपया पुनः प्रयास करें।",
//   "failed_to_create_order": "ऑर्डर बनाने में असमर्थ। कृपया पुनः प्रयास करें।",
//   "failed_to_initialize_payment": "भुगतान शुरू करने में विफल। कृपया थोड़ी देर बाद पुनः प्रयास करें।",
//   "failed_to_open_payment_gateway": "भुगतान विंडो खोलने में असमर्थ। कृपया पुनः प्रयास करें।",

//   // Service Details
//   "birth_chart_analysis": "व्यक्तिगत ज्योतिषीय रिपोर्ट",
//   "complete_kundli_report": "200+ पृष्ठ की वैदिक कुंडली रिपोर्ट - जीवन के सभी क्षेत्रों को कवर करती है",
//   "service_amount": "₹599",

//   // Time of Day Indicators (for emoji display)
//   "morning": "🌅",
//   "afternoon": "☀️",
//   "evening": "🌆",
//   "night": "🌙",

//   // Days of Week
//   "monday": "सोमवार",
//   "tuesday": "मंगलवार", 
//   "wednesday": "बुधवार",
//   "thursday": "गुरुवार",
//   "friday": "शुक्रवार",
//   "saturday": "शनिवार",
//   "sunday": "रविवार",

//   // Months
//   "january": "जनवरी",
//   "february": "फरवरी",
//   "march": "मार्च",
//   "april": "अप्रैल",
//   "may": "मई",
//   "june": "जून",
//   "july": "जुलाई",
//   "august": "अगस्त",
//   "september": "सितंबर",
//   "october": "अक्टूबर",
//   "november": "नवंबर",
//   "december": "दिसंबर"
// };
// export default hiKundli;
